import React from 'react';
import { Modal, Input, Spin } from 'antd';
import styles from './AddMessageModal.module.scss';
import { SET_ADD_TITLE, SET_INBOX_ADD_MESSAGE } from '../../../actions/types';
import { useDispatch, useSelector } from 'react-redux';
import AttachmentPreviewList from "../AttachmentPreviewList/AttachmentPreviewList";

const AddMessageModal = ({
    title,
    isModalOpen,
    handleOk,
    handleCancel,
    clearFields,
    attachments = [],
    onSelectFiles,
    onRemoveAttachment,
    isUploading = false,
    isSubmitting = false,
}) => {
    const { addTitle, inboxAddMessage } = useSelector((state) => state.inboxSeenMessages);
    const dispatch = useDispatch();

    const setAddTitle = (value) => {
        dispatch({ type: SET_ADD_TITLE, payload: value });
    };

    const setAddMessage = (value) => {
        dispatch({ type: SET_INBOX_ADD_MESSAGE, payload: value });
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files || []);
        if (onSelectFiles && files.length) {
            onSelectFiles(files);
        }
        // allow selecting the same file again
        e.target.value = null;
    };

    return (
        <Modal
            title={title}
            open={isModalOpen.status === 'Re-open' ? isModalOpen.open : isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            afterClose={() => clearFields()}
            okButtonProps={{
                disabled: !(addTitle && inboxAddMessage) || isUploading || isSubmitting,
                loading: isSubmitting,
            }}
            cancelButtonProps={{ disabled: isSubmitting }}
            maskClosable={!isSubmitting}
        >
            <Spin spinning={isSubmitting} tip="Creating message...">
                <Input
                    className={styles.addTitleField}
                    disabled={isModalOpen.status === 'Re-open' || isSubmitting}
                    value={addTitle}
                    onChange={e => setAddTitle(e.target.value)}
                    placeholder="Add Title"
                />
                <Input
                    className={styles.addMessageField}
                    disabled={isSubmitting}
                    value={inboxAddMessage}
                    onChange={e => setAddMessage(e.target.value)}
                    placeholder="Add Message"
                />
                <div className={styles.uploadWrapper}>
                    <label className={styles.uploadLabel}>
                        <span>Select images / videos</span>
                        <input
                            type="file"
                            accept="image/*,video/*"
                            multiple
                            className={styles.fileInput}
                            onChange={handleFileChange}
                        />
                    </label>
                    <AttachmentPreviewList
                        items={attachments}
                        onRemove={onRemoveAttachment}
                    />
                </div>
            </Spin>
        </Modal>
    );
};

export default AddMessageModal;
